// extracted by mini-css-extract-plugin
export default {"display_left":"style_display_left__6Fyc2","display_right":"style_display_right__B0bl9","table_wrap":"style_table_wrap__MX-9j"};